import { defineStore } from 'pinia'

/**
 * Mobile menu / filter UI state.
 */
export const useMobileMenusStore = defineStore('mobileMenus', {
  state: () => ({
    mobileFilterStatus: false,
    overviewHeaderActive: false,
  }),
  actions: {
    toggleMobileFilter() {
      this.mobileFilterStatus = !this.mobileFilterStatus
    },
    disableMobileFilter() {
      this.mobileFilterStatus = false
    },
    setOverviewHeaderActive(active: boolean) {
      this.overviewHeaderActive = active
    },
  },
})
